
export class Product {

    public titulo: string;
    public precio: number;
    public impuesto: number;
    public descripcion: string;
    public categoria: string;
    public key?: string;
    public createdAt?: string;
    public modifiedAt?: string;
    public imagenes: IImageProduct[];
    public comercio: string;
    public cantidad?: number;
    public total_producto?: number;
    public stock: number;
    public formato: string;
    public precio_formato: string;
    public peso_reparto: number;
    public peso_variable: boolean;
    public main_image?: IImageProduct;
    public observaciones: string;
    public subcategoria: string;
    public active: boolean;
    public oferta: boolean;
    public mas_vendido: boolean;
    public precio_oferta?: number;
    public first_image: any;
    public second_image: any;
    public third_image: any;
    public stock_comprometido_diario: number;

    constructor(obj?: IProduct) {
        this.titulo = obj && obj.titulo || '';
        this.precio = obj && obj.precio || 0;
        this.impuesto = obj && obj.impuesto || 0;
        this.descripcion = obj && obj.descripcion || '';
        this.categoria = obj && obj.categoria || '';
        this.subcategoria = obj && obj.subcategoria || '';
        this.comercio = obj && obj.comercio || '';
        this.stock = obj && obj.stock || 0;
        this.peso_reparto = obj && obj.peso_reparto || 0;
        this.peso_variable = obj && obj.peso_variable || false;
        this.formato = obj && obj.formato || '';
        this.precio_formato = obj && obj.precio_formato || '';
        this.observaciones = obj && obj.observaciones || '';
        this.active = obj && obj.active || true;
        this.oferta = obj && obj.oferta || false;
        this.mas_vendido = obj && obj.mas_vendido || false;
        this.first_image = obj && obj.first_image || null;
        this.second_image = obj && obj.second_image || null;
        this.third_image = obj && obj.third_image || null;
        this.stock_comprometido_diario = obj && obj.stock_comprometido_diario || null;

        if (obj && obj.precio_oferta) {
            this.precio_oferta = obj.precio_oferta;
        }

        if (obj && obj.cantidad) {
            this.cantidad = obj.cantidad;
        }

        if (obj && obj.total_producto) {
            this.total_producto = obj.total_producto;
        }

        if (obj && obj.imagenes) {
            this.imagenes = obj && obj.imagenes
        }

        if (obj && obj.main_image) {
            this.main_image = obj && obj.main_image
        }

        if (obj && obj.createdAt) {
            this.createdAt = obj.createdAt;
        }

        if (obj && obj.modifiedAt) {
            this.modifiedAt = obj.modifiedAt;
        }

        if (obj && obj.key) {
            this.key = obj.key;
        }
    }
}

export interface IProduct {
    titulo_categoria?: any;
    titulo: string;
    precio: number;
    impuesto: number;
    descripcion: string;
    categoria: string;
    key?: string;
    createdAt?: string;
    modifiedAt?: string;
    imagenes: IImageProduct[];
    comercio: string;
    cantidad?: number;
    total_producto?: number;
    stock: number;
    formato: string;
    precio_formato: string;
    peso_reparto: number;
    peso_variable: boolean;
    main_image?: IImageProduct;
    observaciones: string;
    subcategoria: string;
    media?: any[];
    oferta: boolean;
    mas_vendido: boolean;
    precio_oferta?: number;
    active: boolean;
    first_image: any;
    second_image: any;
    third_image: any;
    stock_comprometido_diario: number;
}

export class ImageProduct {
    public url: string;
    public main: boolean;
    public thumbnail: string;
    public name: string;
    public id: string;
    public path: string;
    public type: string;
    public key?: string;

    constructor(obj?: IImageProduct) {
        this.url = obj && obj.url || '';
        this.thumbnail = obj && obj.thumbnail || '';
        this.name = obj && obj.name || '';
        this.id = obj && obj.id || '';
        this.main = obj && obj.main || false;
        this.path = obj && obj.path || '';
        this.type = obj && obj.type || '';

        if (obj && obj.key) {
            this.key = obj.key;
        }
    }
}

export interface IImageProduct {
    url: string;
    main: boolean;
    thumbnail: string;
    name: string;
    id: string;
    path: string;
    type: string;
    key?: string;

}

export class ProductVars {

    public static readonly UNIDAD = 'UNIDAD';
    public static readonly GRANEL = 'GRANEL';

    public static readonly KILOGRAMOS = 'KILOGRAMOS';
    public static readonly GRAMOS = 'GRAMOS';
    public static readonly CENTILITROS = 'CENTILITROS';
    public static readonly LITROS = 'LITROS';

    public static readonly LIST_IVA = [
        {
            id: 21,
            text: '21'
        },
        {
            id: 10,
            text: '10'
        },
        {
            id: 4,
            text: '4'
        },
    ]

    public static readonly FORMAT = [
        {
            id: ProductVars.KILOGRAMOS,
            text: 'Unidad'
        },
        {
            id: ProductVars.GRANEL,
            text: 'Granel'
        },
    ]

    public static readonly UNIT_FORMAT = [
        {
            id: ProductVars.GRAMOS,
            text: 'Gramos',
            symbol: ''
        },
        {
            id: ProductVars.KILOGRAMOS,
            text: 'Kilogramos'
        },
        {
            id: ProductVars.CENTILITROS,
            text: 'Granel'
        },
        {
            id: ProductVars.LITROS,
            text: 'Granel'
        },
    ]
}
